import React from 'react';
import { Link } from 'react-router-dom';
import { HiArrowRight } from 'react-icons/hi';
import { HiArrowUpRight } from 'react-icons/hi2';
import Reveal from '../../../shared/Reveal/Reveal';
import { useInsightsNewsContent } from '../../../../hooks/useInsightsNewsContent';
import { useMarketAnalysisPosts } from '../../../../hooks/useMarketAnalysisPosts';
import newsImage1 from '../../../../assets/images/insights/news/n1.jpg';
import newsImage2 from '../../../../assets/images/insights/news/n2.jpg';
import newsImage3 from '../../../../assets/images/insights/news/n3.jpg';
import './News.css';

const fallbackImages = [newsImage1, newsImage2, newsImage3];

const News = () => {
  const { content, isLoading: headerLoading } = useInsightsNewsContent();
  const { posts, isLoading: postsLoading } = useMarketAnalysisPosts();

  if (headerLoading || !content) {
    return null;
  }

  const newsPosts = posts.filter((post) => !post.featured).slice(0, 3);
  const { eyebrow, title, cta } = content;

  return (
    <section className="insights-news">
      <div className="insights-news__inner">
        <Reveal className="insights-news__header">
          <div className="insights-news__heading">
            {eyebrow ? <p className="insights-news__eyebrow">{eyebrow}</p> : null}
            <h2 className="insights-news__title">{title}</h2>
          </div>

          {cta?.text && cta?.url ? (
            <Link to={cta.url} className="insights-news__cta">
              {cta.text}
              <HiArrowUpRight className="insights-news__cta-icon" aria-hidden="true" />
            </Link>
          ) : null}
        </Reveal>

        <div className="insights-news__grid">
          {!postsLoading &&
            newsPosts.map((post, index) => (
              <Reveal key={post.slug} delay={index * 80}>
                <article className="insights-news__card">
                  <div className="insights-news__media">
                    <img
                      className="insights-news__image"
                      src={post.image || fallbackImages[index] || newsImage1}
                      alt=""
                      aria-hidden="true"
                    />
                  </div>

                  <div className="insights-news__copy">
                    {post.category ? <p className="insights-news__tag">{post.category}</p> : null}
                    <h3 className="insights-news__card-title">{post.title}</h3>
                    {post.excerpt ? <p className="insights-news__card-text">{post.excerpt}</p> : null}
                    <Link
                      to={`/insights/market-analysis/${post.slug}`}
                      className="insights-news__card-link"
                    >
                      Read Full Analysis
                      <HiArrowRight
                        className="insights-news__card-link-icon"
                        aria-hidden="true"
                      />
                    </Link>
                  </div>
                </article>
              </Reveal>
            ))}
        </div>
      </div>
    </section>
  );
};

export default News;
